// extracted by mini-css-extract-plugin
export default {"wrap":"authLayout_wrap__-sVV8","card":"authLayout_card__StEPs","footer":"authLayout_footer__4q1E7"};